import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  fromRefcode: null,

  accessToken: null,
  accessExpires: null,

  isAuthorized: null,

  loginStatus: null,
  signupStatus: null,
  forgotStatus: null,
  resetStatus: null,
  checkOtpStatus: '', // Added for OTP check status
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setFromRefcode: (state, action) => { state.fromRefcode = action.payload },

    setAccessToken: (state, action) => { state.accessToken = action.payload },
    setAccessExpires: (state, action) => { state.accessExpires = action.payload },

    setIsAuthorized: (state, action) => { state.isAuthorized = action.payload },

    setLoginStatus: (state, action) => { state.loginStatus = action.payload },
    setSignupStatus: (state, action) => { state.signupStatus = action.payload },
    setForgotStatus: (state, action) => { state.forgotStatus = action.payload },
    setResetStatus: (state, action) => { state.resetStatus = action.payload },
    setCheckOtpStatus: (state, action) => { state.checkOtpStatus = action.payload },

    resetAuth: () => initialState,
  },
})

export const {
  setFromRefcode,

  setAccessToken,
  setAccessExpires,

  setIsAuthorized,

  setLoginStatus,
  setSignupStatus,
  setForgotStatus,
  setResetStatus,
  setCheckOtpStatus,

  resetAuth,
} = authSlice.actions

export default authSlice.reducer